/** REV-22155 — filter of the persons overview, remembered in the store (profile → back). */
export interface PersonsFilter {
    textSearch?: string;
    mandateManagerIds?: string[];
    clerkIds?: string[];
    tagIds?: string[];
}
